import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconFileNew from '@/icons/FileNew.svg';

export const RequestCreatedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'request_created'>;
}) => {
  let creatorName = activity.creator?.name ?? activity.storeCreator?.name;

  if (creatorName && activity.data.salesAdvisor) {
    creatorName += ` (${activity.data.salesAdvisor})`;
  }

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      icon={<IconFileNew />}
      type="primary"
      message={
        <BaseActivityText>
          {creatorName ? (
            <Trans id="activities.request_created.message">
              <strong>{creatorName}</strong> created the request
            </Trans>
          ) : (
            <Trans id="activities.request_created.message.client">
              <strong>The client</strong> created the request
            </Trans>
          )}
        </BaseActivityText>
      }
    />
  );
};
